import { ApiProperty } from "@nestjs/swagger";


export class LoginRequest {
    @ApiProperty()
    username: string;
    @ApiProperty()
    password: string;
    @ApiProperty()
    reEnteredPassword?: string;

    /**
     * 
     * @param username 
     * @param password 
     * @param reEnteredPassword
     */
    constructor(username: string, password: string, reEnteredPassword?: string) {
        this.username = username;
        this.password = password;
        this.reEnteredPassword = reEnteredPassword;
    }
}